<template>
  <div class="main">
    <Header
      :show="true"
      title="添加车辆"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-form ref="create" @submit="submit">
        <van-field
          v-model.trim="listQuery.vehicleName"
          label="车辆名称"
          placeholder="请输入车辆名称"
        />
        <van-field
          v-model.trim="listQuery.vehicleNo"
          label="车牌号"
          placeholder="请输入车牌号"
        />
        <van-field
          v-model.trim="listQuery.fuelTankCap"
          label="油箱容量"
          placeholder="请输入油箱容量"
          type="number"
          required
        />
        <van-field
          v-model.trim="listQuery.initMile"
          type="number"
          label="初始里程"
          placeholder="请输入初始里程"
        />
        <van-field
          :value="
            getCarTypeValue(listQuery.typeCode).name || listQuery.typeCode
          "
          label="车辆类型"
          placeholder="请输入车辆类型"
          required
          clickable
          readonly
          is-link
          @click="showtypepicker = true"
        />
        <van-action-sheet
          v-model="showtypepicker"
          :actions="carTypeList"
          cancel-text="取消"
          description="选择车辆类型"
          @select="onCarTypeSelect"
        />
        <div style="margin: 0.6rem 1rem" v-if="checkPermission([402])">
          <van-button round block type="info" native-type="submit">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { createVehicle as createOne } from "@/api/vehicleManager.js";
import { getDicyType } from "@/api/dict";

export default {
  name: "ServiceSystemSupplierCreate",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      isLoading: false,
      loading: false,
      listQuery: {
        vehicleName: undefined,
        vehicleNo: undefined,
        fuelTankCap: undefined,
        initMile: undefined,
        typeCode: "",
      },
      carTypeList: [],
      showtypepicker: false,
    };
  },
  created() {
    this.getCarType();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
      // console.log('dashboard-left')
    },
    getCarTypeValue(code) {
      return this.carTypeList.find((type) => type.value === code) || {};
    },
    onCarTypeSelect({ value }) {
      this.listQuery.typeCode = value;
      this.showtypepicker = false;
    },
    getCarType() {
      const that = this;
      getDicyType({ type: "cartype" })
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const { data: dictData } = data;
            const carTypeDict = dictData?.[0].dictDataList || [];
            const list = [];
            carTypeDict.forEach((dict) => {
              list.push({
                name: dict.label,
                value: dict.code,
              });
            });
            that.carTypeList = list;
          }
        })
        .catch(() => false);
    },
    handleClickRight() {
      this.$refs.create.submit();
    },
    async submit() {
      const payload = {
        ...this.listQuery,
      };

      if (!payload.vehicleName && !payload.vehicleNo) {
        this.$message({
          type: "info",
          message: "请录入车辆信息",
        });
        return;
      }
      if (!payload.fuelTankCap || !payload.typeCode) {
        this.$message({
          type: "info",
          message: "请完善必填信息",
        });
        return;
      }

      Dialog.confirm({
        title: "确认新增车辆？",
      })
        .then(() => {
          this.loading = true;

          createOne(payload)
            .then((response) => {
              const { data } = response;
              if (
                showPhoneAlarm(
                  true,
                  "toast",
                  null,
                  2000,
                  data.code,
                  "新增车辆",
                  data.message
                )
              ) {
                this.$router.go(-1);
              }
              this.loading = false;
            })
            .catch(function (error) {
              this.loading = false;
            });
        })
        .catch(() => {
          showPhoneAlarm(
            true,
            "toast",
            "success",
            2000,
            200,
            "新增供应商",
            "取消"
          );
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
